var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "section--container"
  }, [_vm.addressErrorMessage.length ? _c('AddressErrorModal', {
    attrs: {
      "message": _vm.addressErrorMessage
    },
    on: {
      "confirm": _vm.clearAddressModal
    }
  }) : _vm._e(), _vm._v(" "), _vm.addressSuggestions.length ? _c('AddressSuggestionModal', {
    attrs: {
      "suggestion": _vm.addressSuggestions,
      "original-address": _vm.form.address
    },
    on: {
      "selected": _vm.addressCorrectionSelected
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container max-w-3xl section--content"
  }, [_c('h1', [_vm._v("Is the following information still correct to continue your application?")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "flex flex-col"
  }, [_c('h4', {
    staticClass: "mb-4"
  }, [_vm._v("Full Legal Name")]), _vm._v(" "), _c('div', {
    staticClass: "flex sm:flex-col gap-x-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.first_name,
      expression: "form.first_name"
    }],
    class: [_vm.showFormError.first_name && 'invalid_border', _vm.shakeForm.first_name && 'invalid'],
    attrs: {
      "placeholder": "First name",
      "autocomplete": "given-name",
      "name": "first_name"
    },
    domProps: {
      "value": _vm.form.first_name
    },
    on: {
      "blur": function ($event) {
        return _vm.onFieldBlur('first_name');
      },
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "first_name", $event.target.value);
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.last_name,
      expression: "form.last_name"
    }],
    class: [_vm.showFormError.last_name && 'invalid_border', _vm.shakeForm.last_name && 'invalid'],
    attrs: {
      "placeholder": "Last name",
      "autocomplete": "family-name",
      "name": "last_name"
    },
    domProps: {
      "value": _vm.form.last_name
    },
    on: {
      "blur": function ($event) {
        return _vm.onFieldBlur('last_name');
      },
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "last_name", $event.target.value);
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col"
  }, [_vm._m(0), _vm._v(" "), _c('AddressDropdown', {
    attrs: {
      "autocomplete-result": _vm.autocompleteResult,
      "input-class": [_vm.showFormError.address_street_one && 'invalid_border', _vm.shakeForm.address_street_one && 'invalid'],
      "placeholder": "Address 1",
      "name": "street_one",
      "autocomplete": "address-line1",
      "required": ""
    },
    on: {
      "update:autocompleteResult": function ($event) {
        _vm.autocompleteResult = $event;
      },
      "update:autocomplete-result": function ($event) {
        _vm.autocompleteResult = $event;
      },
      "input": _vm.onAutoCompleteInput,
      "selectAddressHandler": _vm.onSelectAddressHandler,
      "blur": function ($event) {
        return _vm.onFieldBlur('address_street_one');
      }
    },
    model: {
      value: _vm.form.address.street_one,
      callback: function ($$v) {
        _vm.$set(_vm.form.address, "street_one", $$v);
      },
      expression: "form.address.street_one"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.address.street_two,
      expression: "form.address.street_two"
    }],
    class: [_vm.showFormError.address_street_two && 'invalid_border', _vm.shakeForm.address_street_two && 'invalid'],
    attrs: {
      "placeholder": "Address 2",
      "name": "street_two",
      "autocomplete": "address-line2"
    },
    domProps: {
      "value": _vm.form.address.street_two
    },
    on: {
      "blur": function ($event) {
        return _vm.onFieldBlur('address_street_two');
      },
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form.address, "street_two", $event.target.value);
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex gap-x-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.address.city,
      expression: "form.address.city"
    }],
    staticClass: "w-3/6",
    class: [_vm.showFormError.address_city && 'invalid_border', _vm.shakeForm.address_city && 'invalid'],
    attrs: {
      "name": "city",
      "placeholder": "City",
      "autocomplete": "address-level2",
      "required": ""
    },
    domProps: {
      "value": _vm.form.address.city
    },
    on: {
      "blur": function ($event) {
        return _vm.onFieldBlur('address_city');
      },
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form.address, "city", $event.target.value);
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.address.state,
      expression: "form.address.state"
    }],
    staticClass: "w-2/6",
    class: [_vm.showFormError.address_state && 'invalid_border', _vm.shakeForm.address_state && 'invalid'],
    attrs: {
      "placeholder": "State",
      "name": "state",
      "autocomplete": "address-level1",
      "required": ""
    },
    on: {
      "blur": function ($event) {
        return _vm.onFieldBlur('address_state');
      },
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.form.address, "state", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("State")]), _vm._v(" "), _vm._l(_vm.states, function (state) {
    return _c('option', {
      key: state,
      domProps: {
        "value": state
      }
    }, [_vm._v(_vm._s(state))]);
  })], 2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.address.zip_code,
      expression: "form.address.zip_code"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: '#####',
      expression: "'#####'"
    }],
    staticClass: "w-3/6",
    class: [_vm.showFormError.address_zip_code && 'invalid_border', _vm.shakeForm.address_zip_code && 'invalid'],
    attrs: {
      "name": "zip_code",
      "placeholder": "Zip Code",
      "pattern": "[0-9]*",
      "maxlength": "5",
      "required": "",
      "autocomplete": "postal-code"
    },
    domProps: {
      "value": _vm.form.address.zip_code
    },
    on: {
      "blur": function ($event) {
        return _vm.onFieldBlur('address_zip_code');
      },
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form.address, "zip_code", $event.target.value);
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex sm:flex-col gap-x-5"
  }, [_c('div', {
    staticClass: "flex-grow"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.ssn,
      expression: "form.ssn"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: '###-##-####',
      expression: "'###-##-####'"
    }],
    class: [_vm.showFormError.ssn && 'invalid_border', _vm.shakeForm.ssn && 'invalid'],
    attrs: {
      "autocomplete": "off",
      "name": "ssn",
      "placeholder": "000-00-0000",
      "pattern": "\\d{3}-\\d{2}-\\d{4}",
      "maxlength": "11",
      "required": ""
    },
    domProps: {
      "value": _vm.form.ssn
    },
    on: {
      "blur": function ($event) {
        return _vm.onFieldBlur('ssn');
      },
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "ssn", $event.target.value);
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex-grow"
  }, [_c('h4', [_vm._v("Date of Birth")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.date_of_birth,
      expression: "form.date_of_birth"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: '##/##/####',
      expression: "'##/##/####'"
    }],
    class: [_vm.showFormError.date_of_birth && 'invalid_border', _vm.shakeForm.date_of_birth && 'invalid', _vm.isUnder18 && 'is-under-18'],
    attrs: {
      "id": "confirm-info-date_of_birth",
      "name": "date_of_birth",
      "pattern": "\\d{2}/\\d{2}/\\d{4}",
      "autocomplete": "bday",
      "placeholder": "MM/DD/YYYY",
      "required": ""
    },
    domProps: {
      "value": _vm.form.date_of_birth
    },
    on: {
      "blur": function ($event) {
        return _vm.onFieldBlur('date_of_birth');
      },
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "date_of_birth", $event.target.value);
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "block leading-6 text-xs text-red-400",
    class: {
      invisible: !_vm.isUnder18
    },
    attrs: {
      "for": "application-date_of_birth"
    }
  }, [_vm._v("You must be 18 years or older to use Extra.")])])]), _vm._v(" "), _c('button', {
    staticClass: "button--filled mt-8 px-16 sm:w-full",
    attrs: {
      "type": "submit",
      "disabled": !_vm.readyToSubmit || _vm.processing
    }
  }, [_vm._v("\n\t\t\t\tContinue\n\t\t\t")])])])], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "flex flex-col items-start"
  }, [_c('div', {
    staticClass: "flex flex-row items-baseline"
  }, [_c('h4', [_vm._v("Home Address")]), _vm._v(" "), _c('p', {
    staticClass: "mb-2 ml-2 opacity-50 sm-md:hidden"
  }, [_vm._v("(where we ship your card)")])]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 italic opacity-25"
  }, [_vm._v("P.O. Boxes will not be accepted")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "flex flex-row flex-wrap gap-x-2 items-baseline"
  }, [_c('h4', [_vm._v("SSN / ITIN")]), _vm._v(" "), _c('p', {
    staticClass: "whitespace-nowrap opacity-50"
  }, [_vm._v("(to make sure it's actually you)")])]);
}];
export { render, staticRenderFns };